import React from 'react';
import { useNavigate } from 'react-router-dom';
import TeamHoverName from './TeamHoverName';

const STATUS_COLORS = {
  scheduled: 'border-slate-200 bg-white',
  pending_confirmation: 'border-amber-300 bg-amber-50',
  completed: 'border-emerald-300 bg-white',
  bye: 'border-slate-200 bg-slate-50',
};

function TeamSlot({ team, score, isWinner, isBye, onClick }) {
  if (isBye && !team) {
    return (
      <div className="px-3 py-2 text-xs text-slate-400 italic border-b border-slate-100 last:border-b-0">
        BYE
      </div>
    );
  }
  return (
    <div
      className={`flex items-center justify-between px-3 py-2 border-b border-slate-100 last:border-b-0
        ${isWinner ? 'font-bold text-emerald-700 bg-emerald-50' : 'text-slate-600'}
        ${team && onClick ? 'cursor-pointer hover:bg-ocean-50 transition-colors' : ''}
      `}
      onClick={team && onClick ? (e) => { e.stopPropagation(); onClick(team); } : undefined}
    >
      <span className="text-xs truncate max-w-[100px]" title={team?.name}>
        {team ? <TeamHoverName team={team} /> : <span className="text-slate-300">TBD</span>}
      </span>
      {score !== null && score !== undefined && (
        <span className={`text-sm font-bold ml-2 min-w-[1.5rem] text-right ${isWinner ? 'text-emerald-700' : 'text-slate-400'}`}>
          {score}
        </span>
      )}
    </div>
  );
}

export default function BracketMatch({ match, onTeamClick, onMatchClick, showChat = true }) {
  const navigate = useNavigate();
  if (!match) return null;

  const isBye = match.status === 'bye';
  const isCompleted = match.status === 'completed';
  const isPending = match.status === 'pending_confirmation';

  const team1IsWinner = isCompleted && match.winner_id === match.team1_id;
  const team2IsWinner = isCompleted && match.winner_id === match.team2_id;

  const sideLabel = {
    winners: null,
    losers: 'LB',
    third_place: '3rd',
    grand_final: 'GF',
    grand_final_reset: 'GF Reset',
  }[match.bracket_side];

  // When onMatchClick is active, team slot clicks must not block the card click
  const effectiveTeamClick = onMatchClick ? null : onTeamClick;

  return (
    <div
      className={`border rounded-lg overflow-hidden w-44 shadow-sm cursor-pointer hover:shadow-md transition-shadow
        ${STATUS_COLORS[match.status] || STATUS_COLORS.scheduled}
        ${isPending ? 'ring-1 ring-amber-300' : ''}
      `}
      onClick={() => onMatchClick ? onMatchClick(match) : (showChat && navigate(`/matches/${match.id}`))}
      title={isBye ? 'BYE' : `Match #${match.match_number} – Klicken für Details`}
    >
      {sideLabel && (
        <div className="text-[10px] font-bold text-center bg-slate-700 text-white py-0.5 uppercase tracking-widest">
          {sideLabel}
        </div>
      )}
      <TeamSlot
        team={match.team1}
        score={match.score_team1}
        isWinner={team1IsWinner}
        isBye={isBye && !match.team1}
        onClick={effectiveTeamClick}
      />
      <TeamSlot
        team={match.team2}
        score={match.score_team2}
        isWinner={team2IsWinner}
        isBye={isBye && !match.team2}
        onClick={effectiveTeamClick}
      />
      {isPending && (
        <div className="text-[10px] text-amber-600 text-center py-1 bg-amber-50 border-t border-amber-200">
          Bestätigung ausstehend
        </div>
      )}
    </div>
  );
}
